import { render, staticRenderFns } from "./ParcelTracking.vue?vue&type=template&id=0cb5d4d1&"
import script from "./ParcelTracking.vue?vue&type=script&lang=js&"
export * from "./ParcelTracking.vue?vue&type=script&lang=js&"
import style0 from "./ParcelTracking.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports